import { apiCall, API_CONFIG } from './api';

export const orderAPI = {
  getAllOrders: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();

      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.filterType) {
        queryParams.append('filterType', params.filterType);
        
        if (params.filterType === 'date' && params.date) {
          queryParams.append('date', params.date);
        } else if (params.filterType === 'month' && params.month) {
          queryParams.append('month', params.month);
          if (params.year) queryParams.append('year', params.year);
        } else if (params.filterType === 'range' && params.startDate && params.endDate) {
          queryParams.append('startDate', params.startDate);
          queryParams.append('endDate', params.endDate);
        }
      }

      if (params.userId) queryParams.append('userId', params.userId);
      if (params.couponId) queryParams.append('couponId', params.couponId);
      if (params.searchQuery) queryParams.append('searchQuery', params.searchQuery.trim());
      if (params.orderStatus && params.orderStatus !== 'All') queryParams.append('orderStatus', params.orderStatus);
      if (params.driverId && params.driverId !== 'All') queryParams.append('driverId', params.driverId);
      if (params.timeSlot && params.timeSlot !== 'All') queryParams.append('timeSlot', params.timeSlot);
      if (params.orderType) queryParams.append('orderType', params.orderType);
      if (params.stats !== undefined) queryParams.append('stats', params.stats);
      if (params.orders !== undefined) queryParams.append('orders', params.orders);
      if (params.drivers !== undefined) queryParams.append('drivers', params.drivers);
      if (params.timeSlots !== undefined) queryParams.append('timeSlots', params.timeSlots);
      if (params.hasCancelRequest) queryParams.append('hasCancelRequest', 'true');

      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.ORDERS_LIST}?${queryParams.toString()}`,
        { method: 'GET' }
      );
      return response;
    } catch (error) {
      console.error('Failed to fetch orders:', error);
      throw error;
    }
  },

  getOrderDetails: async (orderId) => {
    try {
      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.ORDER_DETAILS}/${orderId}`,
        { method: 'GET' }
      );
      return response;
    } catch (error) {
      console.error('Failed to fetch order details:', error);
      throw error;
    }
  },

  addProductToOrder: async (payload) => {
    try {
      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.ORDER_ADD_PRODUCT}`,
        {
          method: 'POST',
          body: JSON.stringify(payload)
        }
      );
      return response;
    } catch (error) {
      console.error('Failed to add product to order:', error);
      throw error;
    }
  },

  editOrderItem: async (payload) => {
    try {
      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.ORDER_EDIT_ITEM}`,
        {
          method: 'POST',
          body: JSON.stringify(payload)
        }
      );
      return response;
    } catch (error) {
      console.error('Failed to edit order item:', error);
      throw error;
    }
  },

  getAdminPolling: async () => {
    try {
      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.ADMIN_POLLING}`,
        { method: 'GET' }
      );
      return response;
    } catch (error) {
      console.error('Failed to fetch admin polling data:', error);
      throw error;
    }
  },

  cancelRequestAction: async (orderId, action) => {
    try {
      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.ORDER_CANCEL_ACTION}`,
        {
          method: 'POST',
          body: JSON.stringify({ orderId, action })
        }
      );
      return response;
    } catch (error) {
      console.error(`Failed to ${action} order cancellation:`, error);
      throw error;
    }
  },
  
  assignStaff: async (payload) => {
    try {
      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.ORDER_ASSIGN_STAFF}`,
        {
          method: 'POST',
          body: JSON.stringify(payload)
        }
      );
      return response;
    } catch (error) {
      console.error('Failed to assign staff to order:', error);
      throw error;
    }
  },

  updateOrderStatus: async (payload) => {
    try {
      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.ORDER_UPDATE_STATUS}`,
        {
          method: 'POST',
          body: JSON.stringify(payload)
        }
      );
      return response;
    } catch (error) {
      console.error('Failed to update order status:', error);
      throw error;
    }
  },

  updateOrderAddress: async (payload) => {
    try {
      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.ORDER_UPDATE_ADDRESS}`,
        {
          method: 'POST',
          body: JSON.stringify(payload)
        }
      );
      return response;
    } catch (error) {
      console.error('Failed to update order address:', error);
      throw error;
    }
  }
};